module.exports = __webpack_public_path__ + "static/img/Home-LOGO.3819f05b.png";